/**
 * @desc 新建周计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanWeekInfoAddRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/web/plan/week/addPlanInfo',
    data,
  });
}

export function mock(
  data: defs.PlanWeekInfoAddRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/mock/web/plan/week/addPlanInfo',
    data,
  });
}
